module.exports = __webpack_public_path__ + "img/line-analytics-sm.6a79a550.svg";